<template>
  <div class="radio-buttons" :class="{'is-invalid': showValidationError}">
    <label v-if="label && showLabel" :for="inputName">
      <required v-if="required" />
      <span v-html="label" />
    </label>

    <div v-for="option in options" :key="valueForOption(option)" class="form-check">
      <input :id="inputId(option)" v-model="value" type="radio" class="form-check-input" :name="inputName"
             :value="valueForOption(option)" @change="emitNewValue" @focus="$emit('focus')">
      <label class="form-check-label" :for="inputId(option)" v-html="displayNameForOption(option)" />
    </div>

    <p v-if="helpText" class="text-muted">
      {{ helpText }}
    </p>

    <validation-errors v-if="showValidationError" :errors="validationErrors" />
  </div>
</template>

<script>
import radioButtonsInputMixin from './radio-buttons-input-mixin'

export default {
  mixins: [radioButtonsInputMixin],

  props: {
    helpText: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },

    showLabel: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  emits: ['focus']
}
</script>
